import { post } from "aws-amplify/api";

export default async function detectLanguage(text) {
  try {
    // Construct the payload to send to the Lambda function
    // const payload = {
    //   body: { text }, // The text that you want to detect the language for
    // };

    // Call the Lambda function via API Gateway
    const restOperation = post({
      apiName: "learnserbianappRESTapi",
      path: "/detectLanguage",
      options: {
        body: { text: text },
      },
    });

    const { body } = await restOperation.response;
    const response = await body.json();

    // Check if the response contains valid language detection data
    if (response && response.language) {
      // Return the detected language code (e.g., 'ru' for Russian or 'sr' for Serbian)
      return response.language;
    } else {
      // Throw an error if the response format is invalid
      throw new Error("Language detection response is invalid", response.error);
    }
  } catch (error) {
    // Handle errors during the API request
    console.error("Lambda Language Detection API Error:", error);
    return null; // Return null or handle the error as needed
  }
}
